import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConfigurationDisplayModel } from 'src/app/models/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProjectService } from 'src/app/services/project.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-display',
  templateUrl: './display.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class DisplayComponent implements OnInit {

  @ViewChild('ngForm') form!: NgForm;

  configurationController : ConfigurationService;

  constructor(configurationController : ConfigurationService,
    private projectService : ProjectService,
    private utilsService : UtilsService,
    public bsModalRef : BsModalRef) {
      this.configurationController = configurationController;
    }

    ngOnInit(): void {
      this.configurationController.saveChangesState();
    }

    @HostListener('document:keydown.escape', ['$event']) 
    onEscape(event: KeyboardEvent) {
      this.cancelConfiguration(false); // escape key already hides the modal
    }

    cancelConfiguration(hideModal: boolean = true):void {
      this.configurationController.cancelConfigurationPopup();
      hideModal? this.bsModalRef.hide(): false;
    }

    saveConfiguration():void {
      if (!this.projectService.projectEditable()) {
        this.cancelConfiguration();
        return;
      }
      this.configurationController.saveConfigurationPopup(this.form);
      this.bsModalRef.hide();
    }

    retoreDefaults(){
      let displayConfiguration: ConfigurationDisplayModel = new ConfigurationDisplayModel();

      displayConfiguration.mapBackground = "#ffffff";
      displayConfiguration.coordinateFormat = "DMS";
      displayConfiguration.horizontalUnits = "NM";
      displayConfiguration.startDefaultArea = true;
      this.configurationController.currentConfiguration.display = displayConfiguration;
    }
}
